import {NgModule} from '@angular/core';
import {Router, RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './pages/auth/login/login.component';
import {ForgotPasswordComponent} from './pages/auth/forgot-password/forgot-password/forgot-password.component';
import {MainLayoutComponent} from './layout/main-layout/main-layout.component';
import {ErrorComponent} from './layout/errors/error.component';
import {ResourceNotFoundComponent} from './layout/errors/resource-not-found/resource-not-found.component';
import {ResetPasswordComponent} from './pages/auth/forgot-password/reset-password/reset-password.component';
import {AuthGuard} from './shared/services/auth/guards/auth-guard.service';
import {WorkDetailComponent} from "./pages/worklist/work-detail/work-status-detail.component";
import { SecondaryLayoutComponent } from './layout/secondary-layout/secondary-layout.component';

const routes: Routes = [
  //Main Route
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [

      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/dashboard/service/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      //Management Route
      {
        path: 'management',
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Management',
        },
        loadChildren: () =>
          import('./pages/management/management.module').then(
            (m) => m.ManagementModule
          ),
      },

      //Report Route
      {
        path: 'report',
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Report',
        },
        loadChildren: () =>
          import('./pages/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },

      //Organization
      {
        path: 'organization',
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Organization',
        },
        loadChildren: () => import('./pages/organization/organization.module').then(m => m.OrganizationModule),
      },

      // Services
      {
        path: 'service',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/management/services/services.module').then((m) => m.ServiceModule),
      },


      //Definition Route
      {
        path: 'definition',
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Definition',
        },
        loadChildren: () => import('./pages/definition/definition.module').then(m => m.DefinitionModule),
      },

      //Settings
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
      },

      // prices
      {
        path: 'prices',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/prices/prices.module').then((m) => m.PricesModule),
      },
      {
        path: 'holidays',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/holidays/holidays.module').then((m) => m.HolidaysModule),
      },
      {
        path: 'watch',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/watch/watch.module').then((m) => m.WatchModule),
      },
      {
        path: 'watch-emails',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/watch-emails/watch-emails.module').then((m) => m.WatchEmailsModule),
      },
      {
        path: 'vehicle-control',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/vehicle-control/vehicle-control.module').then((m) => m.VehicleControlModule),
      },
      {
        path: 'vehicle-statuses',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/vehicle-statuses/vehicle-statuses.module').then((m) => m.VehicleStatusesModule),
      },

      // instituation
      {
        path: 'instituation',
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'Instituation',
        },
        loadChildren: () =>
          import('./pages/instituation/instituation.module').then((m) => m.InstituationModule),
      },
      {
        path: 'appointment',
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'Appointment',
        },
        loadChildren: () =>
          import('./pages/appointment/appointment.module').then((m) => m.AppointmentModule),
      },
      {
        path: 'announcement/admin',
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'AnnouncementAdmin',
        },
        loadChildren: () =>
          import('./pages/announcement/admin/announcement-admin.module').then((m) => m.AnnouncementAdminModule),
      },
      {
        path: 'announcement/user',
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        data: {
          breadcrumb: 'AnnouncementUser',
        },
        loadChildren: () =>
          import('./pages/announcement/user/announcement-user.module').then((m) => m.AnnouncementUserModule),
      },
      {
        path: 'mobile-status',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/mobile-status/mobile-status.module').then((m) => m.MobileStatusModule),
      },
      {
        path: 'watch-payment-process',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/watch-payment-process/module/watch-payment-process.module').then((m) => m.WatchPaymentProcessModule),
      },
      {
        path: 'duty-earn',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/duty-earn/module/duty-earn.module').then((m) => m.DutyEarnModule),
      },
    ],
  },

  {
    path: 'watch-popup',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/watch/watch.module').then((m) => m.WatchModule),
      },
    ],
  },

  // Secondary Routes
  {
    path: 'portal',
    component: SecondaryLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/dashboard/service/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      }
    ]
  },

  {path: 'mobile', loadChildren: () => import('./mobile/mobile.module').then(m => m.MobileModule)},

  // Payment Modul
  {path: 'payment', loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule)},

  //Auth Route
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'forgot-password/forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'forgot-password/reset-password',
        component: ResetPasswordComponent,
      },
    ],
  },


  //il ilçe
  /*  {
      path: 'location',
      component: MainLayoutComponent,
      children: [
        {
          path: 'city-district', component: CityTownManagementComponent
        }
      ],
    },*/

  //Not Found Route
  {
    path: 'notfound',
    component: ErrorComponent,
    children: [{path: '', component: ResourceNotFoundComponent}],
  },
  {
    path: 'price-info',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    data: {
      breadcrumb: 'Price Info',
    },
    loadChildren: () =>
      import('./pages/price-info/price-info.module').then((m) => m.PriceInfoModule),
  },
  // instituation
  {
    path: 'instituation',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    data: {
      breadcrumb: 'Instituation',
    },
    loadChildren: () =>
      import('./pages/instituation/instituation.module').then((m) => m.InstituationModule),
  },
  {
    path: 'appointment',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    data: {
      breadcrumb: 'Appointment',
    },
    loadChildren: () =>
      import('./pages/appointment/appointment.module').then((m) => m.AppointmentModule),
  },
  {
    path: 'announcement/admin',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    data: {
      breadcrumb: 'AnnouncementAdmin',
    },
    loadChildren: () =>
      import('./pages/announcement/admin/announcement-admin.module').then((m) => m.AnnouncementAdminModule),
  },
  {
    path: 'announcement/user',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    data: {
      breadcrumb: 'AnnouncementUser',
    },
    loadChildren: () =>
      import('./pages/announcement/user/announcement-user.module').then((m) => m.AnnouncementUserModule),
  },
  {
    path: 'case',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/case/case.module').then((m) => m.CaseModule),
  },
  {
    path: 'medical-advice',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
    data: {
      breadcrumb: 'Medical Advice',
    },
    loadChildren: () =>
      import('./pages/medical-advice/medical-advice.module').then((m) => m.MedicalAdviceModule),
  },
  {
    path: 'multinet',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/multinet/multinet.module').then((m) => m.MultinetModule),
  },
   {
    path: 'worklist',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/worklist/worklist.module').then((m) => m.WorklistModule),
  },
  {
    path: 'labmed',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/labmed/labmed.module').then((m) => m.LabmedModule),
  },
    {
    path: 'case-features',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/definition/case-features/case-features.module').then((m) => m.CaseFeaturesModule),
  },
  {
    path: 'bills',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/bills/bills.module').then((m) => m.BillsModule),
  },
  {
    path: 'surveys',
    component: MainLayoutComponent,
    loadChildren: () =>
      import('./pages/surveys/routes/survey.module').then((m) => m.SurveyModule),
  },
  {
    path: 'pool',
    loadChildren: () =>
      import('./pages/surveys/routes/survey-pool.module').then((m) => m.SurveyPoolModule),
  },
  {
    path: 'survey-search',
    component: MainLayoutComponent,
    loadChildren: () =>
      //C:\Users\MP\Desktop\CORE\core-fe\src\app\pages\survey-search\module\survey-search.module.ts
      import('./pages/survey-search/module/survey-search.module').then((m) => m.SurveySearchModule),
  },
  {
    path: 'survey',
    loadChildren: () => import('./pages/surveys/routes/survey-pool.module').then(m => m.SurveyPoolModule),
  },
  {
    path: 'manuel-send-sms-mail',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/definition/manuel-send-sms-mail/route/manuel-send-sms-mail.module').then((m) => m.ManuelSendSmsMailModule),
  },
  {
    path: 'mom-baby-visit',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/mother-and-baby-search-screen/module/mother-and-baby-search.module').then((m) => m.MotherAndBabySearchScreenModule),
  },
  //C:\Users\MP\Desktop\CORE\core-fe\src\app\pages\file\file-cases.module.ts
  {
    path: 'file-case',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/file/file-cases.module').then((m) => m.FileCasesModule),
  },
    {
        path: 'team-statuses',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],

        loadChildren: () =>
          import('./pages/team-statuses/team-statuses.module').then((m) => m.TeamStatusesModule),
      },
  {
    path: 'teams',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],

    loadChildren: () =>
      import('./pages/teams/teams/teams.module').then((m) => m.TeamsModule),
  },

    {
    path: 'field-sale',
    component: SecondaryLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./pages/sales/field-sales/field-sale.module').then((m) => m.FieldSaleModule),
  },
  {path: '**', redirectTo: 'notfound'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private readonly router: Router) {
  }

  resetRouterConfig() {
    this.router.resetConfig(routes);
  }
}
